<!-- shared-layout.component.html -->
<div id="header">
  <div class="color-line"></div>
  <div id="logo" class="light-version">
    <img src="/api/asset/BFE_logo.png" style="height:55px; margin-left:-10px; margin-top:-20px" />
  </div>

  <nav role="navigation">
    <div class="header-link hide-menu"><i class="fa fa-bars"></i></div>
    <div class="small-logo">
      <span class="text-primary">AdvisorOp</span>
    </div>
    <!--<user-menu></user-menu>-->
  </nav>
</div>

<div id="navigation">
  <router-outlet name="sidebar"></router-outlet> <!-- Module-specific navigation -->
</div>

<div id="wrapper">
  <router-outlet></router-outlet> <!-- Module-specific content -->
</div>

<footer class="footer">
  <span class="pull-right">©2024 AdvisorOp, LLC</span>
</footer>
